import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './modules/tagsView'
import loadstatus from './modules/loadingState'
import routeList from './modules/routeList'
import accountInfo from './modules/accountInfo'
import getSubjectId from './modules/getSubject'
import webSockets from './modules/webSocketStore'
import getters from './getters'

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		tagsView,
		loadstatus,
		routeList,
		accountInfo,
		getSubjectId,
		webSockets
	},
	getters
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js